import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { SiHyperledger } from "react-icons/si";
import "jspdf-autotable";
import DataGridComponent from '../../Components/DataGridComponent';
import { TrialBalanceGridHeader, TrialBalanceDetailsHeader } from "./GridHeaders/TrialBalanceGridHeader";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import DataGridShowDetails from "../../Components/DataGridShowDetails";
import { errorAlert } from "../../Components/Alerts";
import { AddActionsButton } from "../../Components/AddElementsButton";
import { AiOutlineClose } from "react-icons/ai";
import ExcelFormat from "../../Components/ExcelConverter/ExcelFormat";
import { financialColumns, financialDetailColumns, financialDetailMappings, financialMappings } from "../../Components/ExcelConverter/FinancialStatement";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";

export default function TrialBalance() {
    const [data, setData] = useState([]);
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);
    const [accountsPartnerDetails, setAccountsDetails] = useState([]);

    const [showallAccounts, setShowAllAccounts] = useState(true);
    const [showDetailAccounts, setShowDetailsAccounts] = useState(false);

    const [accountDetailName, setAccountDetailName] = useState("");

    // Kodi per Marrjen e informatave nga databaza
    const fetchData = async () => {
        try {
            const headers = authHeader();
            const response = await axios.get(ApiLink.API_URL + 'Reports', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
        } catch (error) {
        }
    };

    const totalDebit = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Debit), 0);
    }, [data]);

    const totalCredit = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Credit), 0);
    }, [data]);

    const totalBalance = useMemo(() => {
        // return data.reduce((sum, item) => sum + ((Number(item.Debit) - Number(item.Credit))), 0);
        return data.reduce((sum, item) => sum + Number(item.Balance), 0);

    }, [data]);

    const rows = data.map((item, index) => ({
        id: ++index,
        // ledgerID: item.LedgerID,
        ledgerName: item.LedgerName,
        debit: item.Debit,
        credit: item.Credit,
        balance: item.Balance,
        bilanceSide: item.BilanceSide,
        financialStatement: item.FinancialStatements,
        showDetails: item.LedgerID,
        rowInfo: item
    }));

    const totalAccountDebit = useMemo(() => {
        return accountsPartnerDetails.reduce((sum, item) => sum + Number(item.Debit), 0);
    }, [accountsPartnerDetails]);

    const totalAccountCredit = useMemo(() => {
        return accountsPartnerDetails.reduce((sum, item) => sum + Number(item.Credit), 0);
    }, [accountsPartnerDetails]);

    const totalAccountBalance = useMemo(() => {
        // return data.reduce((sum, item) => sum + ((Number(item.Debit) - Number(item.Credit))), 0);
        return accountsPartnerDetails.reduce((sum, item) => sum + ((Number(item.Debit) - Number(item.Credit))), 0);

    }, [accountsPartnerDetails]);

    const detailsRows = accountsPartnerDetails.map((item, index) => ({
        id: ++index,
        type: item.ActionType,
        ledgerNameSQ: item.LedgerNameSQ,
        comment: item.Comment,
        date: item.Date,
        debit: item.Debit,
        credit: item.Credit,
        progressive: item.Progressive,
    }));

    const fetchAccountsPartnerDetails = async (idNumber, fiscalY) => {
        showDetails();
        try {
            const response = await axios.get(ApiLink.API_URL + 'Reports/TrialBalanceDetails', { headers, params: { ledgerID: idNumber, fiscalYear: fiscalY } });
            setAccountsDetails(response.data);
            setAccountDetailName(response.data[0].LedgerNameSQ)

        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const showDetails = () => {
        setShowAllAccounts(false);
        setShowDetailsAccounts(true);
    }

    const showAllAccounts = () => {
        setShowAllAccounts(true);
        setShowDetailsAccounts(false);
        setAccountsDetails([]);
    }

    useEffect(() => {
        fetchData();
    }, [fiscalYear]);

    return (
        <div className="Crud__Container">
            {showallAccounts && (
                <>
                    <TitleElements
                        icon={SiHyperledger}
                        title="Bilanci Vërtetues"
                    />
                    <ElementsParagraph text="Kjo formë është zhvilluar për të vërifikuar bilancin e llogarive kontabel." />
                    <hr></hr>
                    <ExcelFormat
                        data={data}
                        fileName={`Bilanci Vërtetues`}
                        columns={financialColumns}
                        columnMappings={financialMappings}
                        buttonText="XLSX"
                    />

                    <DataGridShowDetails
                        columns={TrialBalanceGridHeader}
                        rows={rows}
                        fetchAccountsDetails={fetchAccountsPartnerDetails}
                        height={500}
                    />
                    <TotalSummaryComponent
                        fields={[
                            { id: 1, label: 'Debi', value: totalDebit },
                            { id: 2, label: 'Kredi', value: totalCredit },
                            { id: 3, label: 'Bilanci', value: totalBalance },
                        ]}
                    />
                </>
            )}

            {showDetailAccounts && (
                <>
                    <TitleElements
                        icon={SiHyperledger}
                        title="Llogaria në Detale"
                    />
                    <div className="bordere">

                        <ExcelFormat
                            data={accountsPartnerDetails}
                            fileName={`${accountDetailName}-Detale`}
                            columns={financialDetailColumns}
                            columnMappings={financialDetailMappings}
                            buttonText="XLSX"
                        />

                        <div className="butons15">
                            <AddActionsButton
                                text="Mbyll"
                                onClick={showAllAccounts}
                                icon={<AiOutlineClose />}
                                className="button-15"
                            />
                        </div>

                    </div>
                    <DataGridComponent columns={TrialBalanceDetailsHeader} rows={detailsRows} />
                    <TotalSummaryComponent
                        fields={[
                            { id: 1, label: 'Debi', value: totalAccountDebit },
                            { id: 2, label: 'Kredi', value: totalAccountCredit },
                            { id: 3, label: 'Bilanci', value: totalAccountBalance },
                        ]}
                    />
                </>
            )}

        </div>
    )
}